export default __webpack_public_path__ + "static/media/5.f90752d9.jpg";